import { usePTVNAuthentication } from '@ptvn-react/authentication';
import { AxiosResponse } from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { PIClient } from '../../api/PIClient';
import { MyProfileResponse } from '../../api/response/AuthorizeEMarketplace';
import { PTVNResponse } from '../../api/response/BaseResponse';
import { PIResponse } from '../../api/response/PIResponse';
import { useEMarketplaceLayoutContext } from '../../components/layout/EMarketplaceLayoutContext';
import { useModalStack } from '../../components/modal/ModalStackProvider';
import { SomethingWentWrongModal } from '../../components/modal/SomethingWentWrongModal';
import { CurrencyType } from '../../utils/constants/CurrencyConstant';
import { ListLocation } from './PICart/Model/CartModel';
import { useHistory } from 'react-router';
import urljoin from 'url-join';
import PageRoute from '../../utils/constants/PageRoute';
import { SubscriptionPlanPageRoute } from '../SubscriptionPlan/SubscriptionPlanPageRoute';

export interface IPIModuleContext {
  currencyCode: CurrencyType;
  auth: PIResponse.PIPermission.PIPermissionAuth;
  loadingPermission: boolean;
  listLocation: ListLocation[];
  setListLocation: React.Dispatch<React.SetStateAction<ListLocation[]>>;
}

const PIModuleContext = React.createContext<IPIModuleContext | null>(null);

export const PIModuleProvider = (props: React.PropsWithChildren<{}>) => {
  const [auth, setAuth] = useState<PIResponse.PIPermission.PIPermissionAuth>({
    CART: false,
    CREATE_DRAFT_PR: false,
    FORECASTING_CHART: false,
  });
  const [loadingPermission, setLoadingPermission] = useState(false);
  const { push } = useModalStack();
  const { currencyCodeSelected, setRole } = useEMarketplaceLayoutContext();
  const currencyCode = currencyCodeSelected || 'THB';
  const [listLocation, setListLocation] = useState<ListLocation[]>([]);
  const { location } = useHistory();

  const userProfile = usePTVNAuthentication<MyProfileResponse>().extendedUserInformation;

  useEffect(() => {
    setLoadingPermission(true);
    const subscription = PIClient.getPIPermissionAuth().subscribe(
      (res) => {
        setLoadingPermission(false);
        setAuth(res.data.features);
        setListLocation(res.data.borgList);
        setRole(userProfile?.companies[0]?.roles[0].roleName);
      },

      (err: AxiosResponse<PTVNResponse>) => {
        setLoadingPermission(false);
        if (
          !(
            location.pathname ===
            urljoin(PageRoute.SUBSCRIPTION_PLAN, SubscriptionPlanPageRoute.CHOOSE_PLAN)
          )
        ) {
          push(SomethingWentWrongModal, {
            onSubmit: () => {
              window.location.reload();
            },
          });
        }
      },
    );

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return (
    <PIModuleContext.Provider
      value={{
        currencyCode,
        auth,
        loadingPermission,
        listLocation,
        setListLocation,
      }}
    >
      {props.children}
    </PIModuleContext.Provider>
  );
};

export const usePIModuleContext = () => {
  return useContext(PIModuleContext) as IPIModuleContext;
};
